module.exports = __webpack_public_path__ + "static/media/TW-GerardRoss-mobile-411x93.1e661974.jpg";